const fragmentLinkToken = {
	mark: "fragment-link",
	getAttrs: (tok) => tok.attrs,
};

export default fragmentLinkToken;
